import types from './types';

const INITIAL_STATE = {
  detail: {},
  status: 'idle',
  buttonLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.COPA_SARAU_DETAIL:
      return {
        ...state,
        detail: action.payload || INITIAL_STATE.detail,
      };
    case types.COPA_SARAU_LOAD:
      return {
        ...state,
        status: action.payload || INITIAL_STATE.status,
      };
    case types.COPA_SARAU_BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    default:
      return state;
  }
};
